export const SessionVoteManager = {
  getVotedArticles: () => {
    const votes = sessionStorage.getItem('articleVotes');
    return votes ? JSON.parse(votes) : {};
  },

  hasVoted: (articleId) => {
    const votes = SessionVoteManager.getVotedArticles();
    return !!votes[articleId];
  },

  recordVote: (articleId) => {
    const votes = SessionVoteManager.getVotedArticles();
    votes[articleId] = true;
    sessionStorage.setItem('articleVotes', JSON.stringify(votes));
  },

  removeVote: (articleId) => {
    const votes = SessionVoteManager.getVotedArticles();
    delete votes[articleId];
    sessionStorage.setItem('articleVotes', JSON.stringify(votes));
  }
};